import { render, staticRenderFns } from "./CorteTiendaListComponent.vue?vue&type=template&id=39cef844&"
import script from "./CorteTiendaListComponent.vue?vue&type=script&lang=js&"
export * from "./CorteTiendaListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports